import React, { useState, createRef } from 'react'
import { string, bool, func } from 'prop-types'
import { InputBox } from 'components'
import { passwordValidationError, newPasswordValidationError } from 'services/utils/validations/validation-messages'

const Password = ({
  className,
  onChange,
  hasError,
  label,
  errorMsg,
  onBlur,
  handleBlur,
  onPasteCapture,
  autofocus,
  id,
  value,
  autoComplete,
  isNewPassword,
  error,
  isCurretPasswordTab
}) => {
  const [showPassword, setShowPassword] = useState(false)
  const inputEl = createRef()
  const handleShowPasswordClick = () => {
    inputEl.current.focus()
    setShowPassword(!showPassword)
  }

  return (
    <div className="password-container">
      <InputBox
        label={label}
        type={showPassword ? 'text' : 'password'}
        onPasteCapture={onPasteCapture}
        onChange={onChange}
        handleBlur={handleBlur}
        hasError={hasError}
        className={`show-password ${className}`}
        errorMsg={errorMsg}
        onBlur={onBlur}
        autoComplete={autoComplete || 'on'}
        maxLength="128"
        autofocus={autofocus}
        id={id}
        value={value}
        refId={inputEl}
        validation={isNewPassword ? newPasswordValidationError : passwordValidationError}
        isPassword
        error={error}
        isCurretPasswordTab={isCurretPasswordTab}
      />
      <button
        className="button-as-link button-show-password"
        onClick={handleShowPasswordClick}
        type="button"
      >
        {showPassword ? 'Hide' : 'Show'}
      </button>
    </div>
  )
}

Password.propTypes = {
  className: string,
  onChange: func,
  hasError: bool,
  label: string,
  errorMsg: string,
  onBlur: func,
  handleBlur: func,
  onPasteCapture: func,
  autofocus: bool,
  id: string,
  value: string,
  autoComplete: string,
  isNewPassword: bool,
  error: string,
}

Password.defaultProps = {
  className: '',
  onChange: x => x,
  hasError: false,
  label: 'Password',
  errorMsg: '',
  onBlur: () => {},
  handleBlur: () => {},
  onPasteCapture: () => {},
  autofocus: false,
  id: '',
  value: '',
  autoComplete: 'on',
  isNewPassword: false,
  error: '',
}

export default Password
